export default __webpack_public_path__ + "static/media/NavLogo.db121a18.svg";